import { create } from 'zustand'

interface LoadingState {
  isLoading: boolean
  message?: string
}

interface LoadingStore extends LoadingState {
  showLoading: (message?: string) => void
  hideLoading: () => void
}

export const useLoadingStore = create<LoadingStore>((set) => ({
  isLoading: false,
  message: undefined,
  showLoading: (message?: string) => set({ isLoading: true, message }),
  hideLoading: () => set({ isLoading: false, message: undefined }),
}))
